import { render } from "./ExperienceItem.vue?vue&type=template&id=399ec3d2"
import script from "./ExperienceItem.vue?vue&type=script&lang=js"
export * from "./ExperienceItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__